<template>
  <div class="added-docs" data-testid="added-docs">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'AddedDocs',
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/abstract/_variables.scss";

.added-docs {
  overflow-y: auto;
  max-height: 250px;
  margin-top: 16px;
}
</style>
